/* eslint-disable no-alert */
import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React, { useContext, useState } from 'react';
import { Box } from '@mui/system';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import SyncIcon from '@mui/icons-material/Sync';
import { WifiContext } from '../modules/wifi';

const securityNaming = (security) => {
  const check = security.substring(0, 3);
  if (check === 'WPA') return 'WPA';
  if (check === 'WEP') return 'WEP';
  return 'OPEN';
};
const WifiStatusContainer = () => {
  const {
    state: { wifiList, usbState },
    actions: { sendWifiInfo, getWifiList },
  } = useContext(WifiContext);

  const initialState = {
    ssid: '',
    security: 'WPA',
    password: '',
    mac: 'manual',
  };
  const [manualWifi, setmanualWifi] = useState(initialState);
  const [password, setPassword] = useState({});
  const onChangeManual = (e) => {
    const { name, value } = e.target;
    if (value === 'OPEN') {
      setmanualWifi({ ...manualWifi, [name]: value, password: '' });
      return;
    }
    setmanualWifi({ ...manualWifi, [name]: value });
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setPassword({ ...password, [name]: value });
  };
  const onSend = (wifi) => {
    const type = securityNaming(wifi.security);
    if (!usbState) {
      alert('usb 상태를 확인해주세요.');
      return;
    }
    if (type !== 'OPEN' && !wifi.password) {
      alert('비밀번호가 입력되지 않았습니다.');
      return;
    }
    sendWifiInfo(wifi);
    setPassword({});
  };
  return (
    <Card sx={{ width: '100%' }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ m: 2 }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="h5">Wi-Fi 현황</Typography>
          <Chip
            size="small"
            icon={usbState ? <LinkIcon /> : <LinkOffIcon />}
            label="USB 연결"
            color={usbState ? 'success' : 'warning'}
          />
        </Stack>
        <CardActions>
          <IconButton
            color="secondary"
            variant="outlined"
            size="small"
            onClick={() => getWifiList()}
            sx={{ minWidth: 8 }}
          >
            <SyncIcon />
          </IconButton>
        </CardActions>
      </Box>
      <CardContent>
        {wifiList.length === 0 && (
          <Alert color="warning">
            Wi-Fi 목록을 찾을수 없습니다. 웹이라면, 실행파일로 접속해주세요.
          </Alert>
        )}
        {wifiList.length > 0 && (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>이름</TableCell>
                <TableCell>접속 방식</TableCell>
                <TableCell>비밀번호</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableRow>
              <TableCell>
                <TextField
                  name="ssid"
                  placeholder="연결하고자 하는 Wi-Fi명을 입력하세요."
                  value={manualWifi.ssid || ''}
                  onChange={onChangeManual}
                  fullWidth
                />
              </TableCell>
              <TableCell>
                <FormControl fullWidth>
                  <Select
                    labelId="security-select-label"
                    id="security-select"
                    name="security"
                    onChange={onChangeManual}
                    value={manualWifi.security || ''}
                  >
                    <MenuItem value="WPA">WPA</MenuItem>
                    <MenuItem value="WEP">WEP</MenuItem>
                    <MenuItem value="OPEN">OPEN</MenuItem>
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                <TextField
                  name="password"
                  value={manualWifi.password || ''}
                  onChange={onChangeManual}
                  disabled={manualWifi.security === 'OPEN'}
                  fullWidth
                />
              </TableCell>
              <TableCell>
                <Button
                  onClick={() => onSend({ ...manualWifi })}
                  color="secondary"
                  variant="contained"
                >
                  연결
                </Button>
              </TableCell>
            </TableRow>
            {wifiList.map(({ mac, ssid, security, ...rest }) => (
              <TableRow key={mac}>
                <TableCell key={`${mac}_ssid`}>
                  <div style={{ marginLeft: '0.75rem' }}>{ssid}</div>
                </TableCell>
                <TableCell key={`${mac}_security`}>
                  <div style={{ marginLeft: '0.75rem' }}>
                    {securityNaming(security)}
                  </div>
                </TableCell>
                <TableCell key={`${mac}_input`}>
                  <TextField
                    name={`${mac}`}
                    value={password[mac] || ''}
                    onChange={onChange}
                    disabled={securityNaming(security) === 'OPEN'}
                    fullWidth
                  />
                </TableCell>
                <TableCell key={`${mac}_save`}>
                  <Button
                    onClick={() =>
                      onSend({ ...rest, password: password[mac] || '' })
                    }
                    size="small"
                    color="secondary"
                    variant="contained"
                  >
                    연결
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default WifiStatusContainer;
